








































import { Component, Vue } from 'vue-property-decorator';
import { ApiPermissions } from '@/core/security/Permissions';
import { RealmApi } from '@/services/api/api.realms';
import bus from '@/core/bus';
import { BusConstants, ModalConstants } from '@/core/constants';
import { RealmLogType } from '@/types/apiServerContract';

@Component
export default class UpdateRealmSecurity extends Vue {
	permissions: string[] = [ApiPermissions.Realm.UploadWoWExe];
	loading = false;
	PatchFiles: string[] = [];
    selectedPatchFile: string = '';

    async deletePatchFile() {
        if (!this.selectedPatchFile) return;

        this.loading = true;

        try {
            const result = await RealmApi.DeleteWoWExe({
                fileName: this.selectedPatchFile
            });

            this.selectedPatchFile = '';

            if (result) {
                this.getPatchFiles();

                this.$bvToast.toast('File deleted successfully', {
                    variant: 'success',
                    title: 'Success'
                });
            }
        } finally {
            this.loading = false;
        }
    }

    async getPatchFiles() {
	    const result = await RealmApi.GetWoWExeFile();
	    this.PatchFiles = result.data ? [result.data] : [];
    }

    created() {
	    this.getPatchFiles();
	    bus.on(BusConstants.SelectedRealmChanged, this.getPatchFiles);
    }

    beforeDestroy() {
	    bus.off(BusConstants.SelectedRealmChanged, this.getPatchFiles);
    }

    showHistory() {
	    bus.emit(BusConstants.RealmLogHistoryType, RealmLogType.GameWoWExeDeleted);
	    this.$bvModal.show(ModalConstants.RealmLogHistoryWindow);
    }
}
